import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { Icon } from '../../Icon/Icon.es.js';

const ModalBasicClose = ({ position = 'top-right', className, onClick, locale = {
    close: 'Close'
}, ...props })=>{
    return jsx(Button, {
        className: classNames('cb-modal-basic-close', position, className),
        "data-testid": "close-button",
        label: locale.close,
        onClick: onClick,
        size: "sm",
        variant: "secondary",
        iconOnly: true,
        ...props,
        children: jsx(Icon, {
            name: "XSolid",
            size: 24
        })
    });
};
ModalBasicClose.displayName = 'Modal.BasicClose';

export { ModalBasicClose };
//# sourceMappingURL=Modal.BasicClose.es.js.map
